export default class PaymentFormItem {
    public Id: string = '';
    public Name: string = '';
    public Value: string = '';
}